var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"v-mentioned-users"},_vm._l((_vm.users),function(user){return _c('span',{key:user.id,on:{"click":function($event){$event.stopPropagation();return _vm.onClick(user.id)}}},[_vm._v(" @"+_vm._s(user.nickname)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }